import { gsap } from '../globals/gsap';

class IntroAnimation {
  constructor($el) {
    this.$el = $el;
    this.$animation = this.$el.find('[data-intro-animation="animation"]');
    this.$rectangle = this.$el.find('[data-intro-animation="rectangle"]');
    this.$main = $('main');
    this.json = $el.data('json');


    this.init();
  }

  init() {

    if(sessionStorage.getItem('intro')) {
      this.$el.remove();
      return;
    }


    // dynamic import lottie from lottie-web
    import(/* webpackChunkName: "lottie" */ 'lottie-web').then(lottie => {

      sessionStorage.setItem('intro', true);

      // load animation
      this.animation = lottie.loadAnimation({
        container: this.$animation[0],
        renderer: 'svg',
        loop: false,
        autoplay: true,
        path: this.json,
      });

      gsap.set(this.$main, {
        opacity: 0,
      });

      this.animation.setSpeed(2.5);

      this.animation.addEventListener('complete', () => {

        const tl = gsap.timeline();

        tl.to(this.$rectangle, {
          scale: 1,
          ease: "power2.inOut",
          duration: 1,
          onComplete: () => {
            // remove this.$el from dom
            this.$el.remove();
          }
        });

        tl.to(this.$main, {
          opacity: 1,
          duration: 1,
        });

      });
    });

  }
}

export default IntroAnimation;